// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d16cc395","239":"4b050ff9","667":"6e7ad84c"}[chunkId] + ".chunk.js";
};